import { http, getApiUrl } from './request'
// import axios from 'axios'




export const updatePassword = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/user/update-password'), payload);
}

export const currentUserInfo = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/user/current-user-info'), payload);
}
